import { AlertCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { useCallback, useRef, useState } from "react";
import { useClickOutside } from "shared/hooks/use-click-outside";
import { ValidationError } from "../store";

export const ValidationsPopover = ({
  errors,
  onNavigate
}: {
  errors: ValidationError[];
  onNavigate: (error: ValidationError) => void;
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const close = useCallback(() => setOpen(false), []);
  useClickOutside(ref, close);

  if (errors.length === 0) return null;

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1.5 rounded-lg border border-danger-500 bg-danger-50 px-3 h-9 text-sm font-medium text-danger-600 hover:bg-danger-100 transition-colors"
      >
        <HugeiconsIcon icon={AlertCircleIcon} size={16} />
        <span>
          {errors.length} {errors.length === 1 ? "error" : "errors"}
        </span>
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-2 w-[360px] max-h-[320px] overflow-y-auto rounded-lg border border-alpha-100 bg-white shadow-lg z-50">
          <div className="px-3 py-2 border-b border-alpha-60 text-xs font-semibold text-content-600 uppercase tracking-wide">
            Validation errors
          </div>
          <ul>
            {errors.map((error, i) => (
              <li key={i}>
                <button
                  type="button"
                  className="w-full text-left px-3 py-2.5 text-sm text-content-800 hover:bg-background-900 transition-colors flex items-start gap-2 border-b border-alpha-40 last:border-b-0"
                  onClick={() => {
                    onNavigate(error);
                    setOpen(false);
                  }}
                >
                  <span className="shrink-0 mt-2 w-1.5 h-1.5 rounded-full bg-danger-500" />
                  <span>{error.message}</span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
